import { render } from "./HelloWorld.vue?vue&type=template&id=2025333c&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=2025333c&scoped=true&lang=css"

import exportComponent from "/Users/sugo/Projects/others/vue_sample/test-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2025333c"]])

export default __exports__